import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserWithToken } from '@deckplan.io/common/users';

const HTTP_UNAUTH_CODE = 401;
const HTTP_LOCKED_CODE = 423;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    public loginForm: FormGroup;
    public error: string;

    @ViewChild('email', {static: true}) public emailInput: ElementRef;

    private returnUrl: string;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly authService: AuthService,
                private readonly router: Router,
                private readonly route: ActivatedRoute) {
        const currentUser = this.authService.currentUserValue;
        if (currentUser) {
            this.router.navigate([currentUser.isAdmin ? '/admin/dashboard' : 'home']);
        }
    }

    public ngOnInit() {
        this.loginForm = this.formBuilder.group({
            email: ['', Validators.required],
            password: ['', Validators.required]
        });
        this.emailInput.nativeElement.focus();
        this.returnUrl = this.route.snapshot.queryParams?.returnUrl || '/home';
    }

    public onSubmit() {
        if (this.loginForm.invalid) {
            return;
        }

        this.error = null;

        this.authService.login(this.loginForm.controls.email.value, this.loginForm.controls.password.value)
            .subscribe(
                (user: UserWithToken) => {
                    const url = this.returnUrl === '/' && user.isAdmin ? '/admin/dashboard' : this.returnUrl;
                    this.router.navigate([url]);
                },
                err => {
                    if (err.status === 0) {
                        this.error = 'We couldn\'t reach the server! Maybe your interwebs are stuck?';
                    } else if (err.status === HTTP_UNAUTH_CODE) {
                        this.error = 'Incorrect username and password!';
                    } else if (err.status === HTTP_LOCKED_CODE) {
                        this.error = 'Email has not been verified! Please check your inbox for an email from no-reply@deckplan.io';
                    } else {
                        this.error = 'An unknown error has occurred! Please try back later :(';
                    }
                }
            );
    }

}
